module.exports = __webpack_public_path__ + "img/time_keeper_light_with_text_pro.7b5995e6.svg";